/* Heretic Coffee Co. — wholesale
   The sliders on the wholesale page and in the portal (snippets/wholesale-offers.liquid), the
   portal's tabs and order history (sections/wholesale-portal.liquid).
   Every price comes from the page's own JSON (Theme settings → Wholesale). The public page sends
   "start an account" to the people-fed worker's /wholesale/inquiry; the portal sends orders to
   /wholesale/order and reads /wholesale/history, each with the token the page was signed with.
   The worker works the totals out again from those signed prices, so this file only shows them.
   Shop mode (a Shopify B2B buyer): the prices come from the Heretic Wholesale catalog (the page's
   data-wh-shop JSON), each coffee has its own − n + stepper, and "Continue to checkout" fills the
   cart (bags per coffee, the pounds on one line with the split written on it, so the price breaks
   count every pound) and goes on to Shopify's checkout, where it is paid. */
(function () {
  'use strict';
  if (window.HereticWholesale) return; /* already on the page: two sections each load this file */
  var doc = document;

  var money0 = function (n) { return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 }); };
  var money2 = function (n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var int = function (n) { return Math.round(n).toLocaleString('en-US'); };
  var cents = function (n) { return Math.round(n * 100) / 100; };

  function post(url, body, timeoutMs) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var cutoff = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs || 20000);
    return fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) { clearTimeout(cutoff); return res; }, function (e) { clearTimeout(cutoff); throw e; });
  }
  function feedBase(el) { var f = String(el.getAttribute('data-feed') || '').replace(/\/+$/, ''); return /^https:\/\//i.test(f) ? f : ''; }

  /* ---------- the calculator ---------- */
  function Calc(root) {
    var P;
    try { P = JSON.parse(root.querySelector('[data-wh-prices]').textContent); } catch (e) { return; }
    var shopMode = root.getAttribute('data-mode') === 'shop';
    if (shopMode) {
      var shopData = null, holder = root.parentNode && root.parentNode.querySelector('[data-wh-shop]');
      try { shopData = JSON.parse(holder.textContent); } catch (e) { shopData = null; }
      if (!shopData) return;
      Object.keys(shopData).forEach(function (k) { P[k] = shopData[k]; });
    }
    var tiers = (P.tiers || []).filter(function (t) { return t && t[1] > 0; }).sort(function (a, b) { return a[0] - b[0]; });
    if (!tiers.length) tiers = [[0, 17]];
    var quote = root.getAttribute('data-mode') === 'quote'; /* shop mode is a one-off order, not a monthly estimate */
    var perMeal = Math.max(1, P.perMeal || 2);
    function q(name) { return root.querySelector('[data-wh="' + name + '"]'); }
    var sheetEl = null;
    function set(name, text) { var el = q(name) || (sheetEl && sheetEl.querySelector('[data-wh="' + name + '"]')); if (el) el.textContent = text; }
    var bagsIn = root.querySelector('[data-wh-in="bags"]'), lbsIn = root.querySelector('[data-wh-in="lbs"]'), ghostIn = root.querySelector('[data-wh-in="ghost"]');
    var setupIn = root.querySelector('[data-wh-in="setup"]'), setupRow = root.querySelector('[data-wh-setup-row]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-wh-step]'));
    var marks = q('marks'), MAX_MARKS = 30, markNodes = [];
    if (marks) for (var m = 0; m < MAX_MARKS; m++) { var dot = doc.createElement('span'); marks.appendChild(dot); markNodes.push(dot); }
    var state = {};

    function tierIndex(lb) { var i = 0; for (var t = 0; t < tiers.length; t++) if (lb >= tiers[t][0]) i = t; return i; }

    /* the sliding-scale table, built once from the prices */
    var tbody = root.querySelector('[data-wh="tiers"] tbody'), tierRows = [];
    if (tbody) {
      var showMargin = P.costLb > 0;
      var mh = q('marginHead'); if (mh && !showMargin) mh.hidden = true;
      tiers.forEach(function (t, i) {
        var next = tiers[i + 1];
        var tr = doc.createElement('tr');
        var a = doc.createElement('th'); a.scope = 'row';
        a.textContent = i === 0 && next ? 'Under ' + next[0] + ' lbs' : next ? t[0] + ' – ' + (next[0] - 1) + ' lbs' : t[0] + ' lbs and up';
        var b = doc.createElement('td'); b.textContent = money2(t[1]) + ' / lb';
        tr.appendChild(a); tr.appendChild(b);
        if (showMargin) { var c = doc.createElement('td'); c.textContent = ((t[1] - P.costLb) / t[1] * 100).toFixed(1) + '%'; tr.appendChild(c); }
        tbody.appendChild(tr); tierRows.push(tr);
      });
    }

    function fill(range) {
      if (!range) return;
      var pct = (range.value - range.min) / ((range.max - range.min) || 1) * 100;
      range.style.setProperty('--fill', pct + '%');
    }

    function render() {
      var bags = bagsIn ? parseInt(bagsIn.value, 10) || 0 : 0;
      var lbs = lbsIn ? parseInt(lbsIn.value, 10) || 0 : 0;
      var ghost = !!(ghostIn && ghostIn.checked);
      var ti = tierIndex(lbs), rate = tiers[ti][1];
      var bagsCost = cents(bags * P.bag), ghostCost = ghost ? cents(bags * P.ghost) : 0, lbsCost = cents(lbs * rate);
      var total = cents(bagsCost + ghostCost + lbsCost);
      var setup = quote && ghost ? P.setup : 0;
      var setupNow = shopMode && ghost && bags > 0 && setupIn && setupIn.checked && P.setupId ? P.setup : 0;
      if (setupRow) setupRow.hidden = !ghost;
      total = cents(total + setupNow);
      var drinks = lbs * (P.drinksLb || 25);
      var give = (bags + lbs) * P.give;
      var people = Math.floor((bags + lbs) / perMeal), bagPeople = Math.floor(bags / perMeal), lbPeople = Math.floor(lbs / perMeal);
      state = { bags: bags, lbs: lbs, ghost: ghost, rate: rate, bagsCost: bagsCost, ghostCost: ghostCost, lbsCost: lbsCost, total: total, setup: setup, setupNow: setupNow, give: give, people: people };
      var sn = q('liSetupNow'); if (sn) sn.hidden = !setupNow; set('liSetupNowAmt', money2(setupNow));
      var ss = sheetEl && sheetEl.querySelector('[data-wh="shSetup"]'); if (ss) ss.hidden = !setupNow; set('shSetupAmt', money2(setupNow));

      fill(bagsIn); fill(lbsIn);
      /* bags */
      set('bagCount', bags);
      set('bagRate', money2(P.bag + (ghost ? P.ghost : 0)) + ' / bag');
      set('bagCost', money0(bagsCost + ghostCost));
      set('bagCostSub', (ghost ? 'Includes ' + money2(P.ghost) + ' a bag for Ghost Roasting · ' : '') + (quote ? money0((bagsCost + ghostCost) * 12) + ' a year at this pace' : bags + ' × ' + money2(P.bag)));
      set('bagKeep', money0(bags * (P.retail - P.bag)));
      set('bagKeepSub', P.retail > 0 ? ((P.retail - P.bag) / P.retail * 100).toFixed(1) + '% on every bag you sell' : '');
      set('bagGive', money2(bags * P.give));
      set('bagPeople', int(bagPeople));
      set('bagPeopleSub', quote ? int(bagPeople * 12) + ' breakfasts a year, served by you' : (perMeal === 2 ? 'Two bags put a hot breakfast and a coffee in someone’s hands' : perMeal + ' bags feed one person'));
      for (var i = 0; i < markNodes.length; i++) markNodes[i].className = i < bagPeople ? 'on' : '';
      /* weight */
      set('lbCount', lbs);
      set('lbRate', money2(rate) + ' / lb');
      set('lbCost', money0(lbsCost));
      set('lbBags', int(Math.ceil(lbs / 5)) + ' five-pound bag' + (Math.ceil(lbs / 5) === 1 ? '' : 's'));
      set('lbDrinks', int(drinks));
      set('lbDrinksSub', 'At an 18 g double, roughly ' + (P.drinksLb || 25) + ' per pound');
      set('lbPerDrink', drinks ? money2(lbsCost / drinks) : '$0.00');
      set('lbGive', money2(lbs * P.give));
      set('lbGiveSub', int(lbPeople) + ' people fed · ' + money2(P.give) + ' a pound');
      tierRows.forEach(function (tr, r) { tr.classList.toggle('is-on', lbs > 0 && r === ti); });
      /* ticket */
      var li = function (name, on) { var el = q(name); if (el) el.classList.toggle('is-void', !on); };
      li('liBags', bags); set('liBagsSub', bags ? bags + ' × ' + money2(P.bag) : 'None' + (quote ? ' this month' : ''));
      set('liBagsAmt', money2(bagsCost));
      var g = q('liGhost'); if (g) g.hidden = !(ghost && bags);
      set('liGhostSub', bags + ' × ' + money2(P.ghost)); set('liGhostAmt', money2(ghostCost));
      li('liLbs', lbs); set('liLbsSub', lbs ? lbs + ' lbs × ' + money2(rate) : 'None' + (quote ? ' this month' : ''));
      set('liLbsAmt', money2(lbsCost));
      set('liTotal', money2(total));
      var su = q('liSetup'); if (su) su.hidden = !setup; set('liSetupAmt', money2(setup));
      set('liGiveAmt', money2(give));
      /* the same ticket, repeated at the top of the form's sheet */
      set('shBagsSub', bags ? bags + ' × ' + money2(P.bag) : 'None'); set('shBagsAmt', money2(bagsCost));
      var sg = q('shGhost') || (sheetEl && sheetEl.querySelector('[data-wh="shGhost"]')); if (sg) sg.hidden = !(ghost && bags); set('shGhostSub', bags + ' × ' + money2(P.ghost)); set('shGhostAmt', money2(ghostCost));
      set('shLbsSub', lbs ? lbs + ' lbs × ' + money2(rate) : 'None'); set('shLbsAmt', money2(lbsCost));
      set('shTotal', money2(total));
      set('liGiveSub', int(people) + ' people fed' + (quote ? ' · ' + int(people * 12) + ' a year' : ''));
    }

    function summary() {
      var L = [];
      if (state.bags) L.push('Retail bags: ' + state.bags + ' x ' + money2(P.bag) + ' = ' + money2(state.bagsCost));
      if (state.ghost && state.bags) L.push('Ghost Roasting: ' + state.bags + ' x ' + money2(P.ghost) + ' = ' + money2(state.ghostCost));
      if (state.lbs) L.push('Coffee by weight: ' + state.lbs + ' lbs x ' + money2(state.rate) + ' = ' + money2(state.lbsCost));
      L.push((quote ? 'Monthly total: ' : 'Order total: ') + money2(state.total));
      if (state.setup) L.push('Ghost Roasting setup (one time): ' + money2(state.setup));
      L.push('Feeds ' + state.people + ' people (' + money2(state.give) + ' to the SNAP Breakfast Program)');
      return L.join('\n');
    }

    [bagsIn, lbsIn].forEach(function (el) { if (el) el.addEventListener('input', render); });
    if (ghostIn) ghostIn.addEventListener('change', render);
    if (setupIn) setupIn.addEventListener('change', render);

    /* shop mode: the steppers, one per coffee, add up into the hidden totals the ticket reads */
    function stepOf(st) { return Math.max(1, parseInt(st.getAttribute('data-step'), 10) || 1); }
    function amount(st) { var n = parseInt(st.querySelector('input').value, 10); return isNaN(n) || n < 0 ? 0 : n; }
    function tally() {
      var sum = { bags: 0, lbs: 0 };
      steps.forEach(function (st) { sum[st.getAttribute('data-wh-step')] += amount(st); });
      if (bagsIn) bagsIn.value = String(sum.bags);
      if (lbsIn) lbsIn.value = String(sum.lbs);
      render();
    }
    steps.forEach(function (st) {
      var box = st.querySelector('input'), size = stepOf(st);
      function put(n) { n = Math.max(0, Math.min(9999, Math.round(n / size) * size)); box.value = String(n); st.classList.toggle('is-on', n > 0); tally(); }
      st.querySelector('[data-wh-dec]').addEventListener('click', function () { put(amount(st) - size); });
      st.querySelector('[data-wh-inc]').addEventListener('click', function () { put(amount(st) + size); });
      box.addEventListener('change', function () { put(amount(st)); });
      box.addEventListener('input', function () { st.classList.toggle('is-on', amount(st) > 0); tally(); });
      st.whPut = put;
    });
    function stepsSplit(kind, unit) {
      return steps.filter(function (st) { return st.getAttribute('data-wh-step') === kind && amount(st) > 0; })
        .map(function (st) { return st.getAttribute('data-name') + ' ' + amount(st) + (unit ? ' ' + unit : ''); }).join(', ');
    }
    render();

    /* ---- sending ---- */
    /* the form lives in a sheet; signup-forms.js may already have moved that sheet to the end of <body>, so find it by name */
    var sheetName = (root.querySelector('[data-wh-open]') || {}).getAttribute ? (root.querySelector('[data-wh-open]').getAttribute('href') || '').replace(/^#/, '') : '';
    var sheet = root.querySelector('[data-sf-sheet]') || (sheetName ? doc.querySelector('[data-sf-sheet="' + sheetName + '"]') : null) || root;
    sheetEl = sheet; render();
    var form = sheet.querySelector('[data-wh-form]'), note = sheet.querySelector('[data-wh-note]'), send = sheet.querySelector('[data-wh-send]');
    var sent = sheet.querySelector('[data-wh-sent]'), sentText = sheet.querySelector('[data-wh-sent-text]'), sentTitle = sheet.querySelector('[data-wh-sent-title]');
    var noteText = note ? note.textContent : '';
    /* the ticket's button opens the form's sheet (signup-forms.js); with nothing chosen it says so instead */
    var opener = root.querySelector('[data-wh-open]'), ticketNote = root.querySelector('[data-wh-ticket-note]'), ticketNoteText = ticketNote ? ticketNote.textContent : '';
    if (opener) {
      opener.addEventListener('click', function (e) {
        render();
        if (!state.bags && !state.lbs) { e.preventDefault(); if (ticketNote) { ticketNote.textContent = shopMode ? 'Pick a coffee first — there is nothing to order yet.' : 'Move a slider first — there is nothing to order yet.'; ticketNote.classList.add('is-alert'); } return; }
        if (ticketNote) { ticketNote.textContent = ticketNoteText; ticketNote.classList.remove('is-alert'); }
      });
    }
    var base = feedBase(root);
    function say(msg, bad) { if (!note) return; note.textContent = msg; note.classList.toggle('is-alert', !!bad); }
    function field(name) { return form ? form.elements[name] : null; }
    function value(name) { var f = field(name); return f ? String(f.value || '').trim() : ''; }
    function flag(name, bad) { var f = field(name); if (f) { var fld = f.closest('.sf-field'); if (fld) fld.classList.toggle('is-err', bad); f.setAttribute('aria-invalid', bad ? 'true' : 'false'); } }

    if (form) {
      form.addEventListener('submit', function (e) {
      e.preventDefault();
      render();
      if (!state.bags && !state.lbs) { say(shopMode ? 'Pick a coffee first — there is nothing to order yet.' : 'Move a slider first — there is nothing to order yet.', true); return; }
      if (shopMode) { checkout(); return; }
      if (!base) { say('Sending isn’t set up on this page yet. Please email us your order.', true); return; }
      var req;
      if (quote) {
        var badShop = !value('shop'), badEmail = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value('email'));
        flag('shop', badShop); flag('email', badEmail);
        if (badShop || badEmail) { say(badShop ? 'Tell us the shop name.' : 'We need an email address to write back to.', true); field(badShop ? 'shop' : 'email').focus(); return; }
        req = post(base + '/wholesale/inquiry', { website: value('website'), fields: { shop: value('shop'), name: value('name'), email: value('email'), phone: value('phone'), delivery: value('delivery'), notes: value('notes') }, estimate: summary() });
      } else {
        req = post(base + '/wholesale/order', { token: root.getAttribute('data-wh-token'), sig: root.getAttribute('data-wh-sig'),
          order: { bags: state.bags, lbs: state.lbs, ghost: state.ghost, delivery: value('delivery'), notes: value('notes'), contact: value('contact'), phone: value('phone') } }, 30000);
      }
      send.disabled = true; say('Sending…');
      req.then(function (res) {
        if (res.status >= 200 && res.status < 300 && res.body && res.body.ok) {
          form.hidden = true;
          if (sent) { sent.hidden = false; var sc = sent.closest('[data-sf-scroll]'); if (sc) sc.scrollTop = 0; sent.focus({ preventScroll: true }); sent.scrollIntoView({ block: 'nearest' }); }
          if (!quote && res.body.number) {
            if (sentTitle) sentTitle.textContent = 'Order ' + res.body.number + ' is in.';
            if (sentText) sentText.textContent = (res.body.totals ? money2(res.body.totals.total) + '. ' : '') + 'We’ll confirm it and send the invoice to the email on your account.';
            root.dispatchEvent(new CustomEvent('wh:ordered', { bubbles: true }));
          } else if (sentText) sentText.textContent = 'We’ll write back to ' + value('email') + '.';
          return;
        }
        say(res.body && res.body.error ? String(res.body.error).charAt(0).toUpperCase() + String(res.body.error).slice(1) + '.' : 'That didn’t go through. Try again in a minute, or email us.', true);
      }).catch(function () { say('That didn’t go through — it never reached us. Try again in a minute, or email us.', true); })
        .then(function () { send.disabled = false; });
    });
    }
    /* shop mode: fill the cart with this order and go on to Shopify's checkout */
    function checkout() {
      var lbStep = Math.max(1, P.lbStep || 5), lbMin = Math.max(0, P.lbMin || 0);
      if (state.lbs && (state.lbs % lbStep || state.lbs < lbMin)) { say('Coffee by weight goes in steps of ' + lbStep + ' lbs' + (lbMin > lbStep ? ', at least ' + lbMin : '') + '.', true); return; }
      var items = [];
      steps.forEach(function (st) { if (st.getAttribute('data-wh-step') === 'bags' && amount(st) > 0) items.push({ id: Number(st.getAttribute('data-id')), quantity: amount(st) }); });
      if (state.ghost && state.bags && P.ghostId) items.push({ id: P.ghostId, quantity: state.bags });
      if (state.setupNow && P.setupId) items.push({ id: P.setupId, quantity: 1 });
      if (state.lbs) items.push({ id: P.lbId, quantity: state.lbs, properties: { Coffees: stepsSplit('lbs', 'lb') } });
      var root0 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      function call(path, body) {
        return fetch(root0 + path, { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify(body || {}), credentials: 'same-origin' })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var err = new Error(j.description || j.message || 'cart'); err.shown = !!(j.description || j.message); throw err; } return j; }); });
      }
      send.disabled = true; say('Getting your cart ready…');
      call('cart/clear.js')
        .then(function () { return call('cart/add.js', { items: items }); })
        .then(function () {
          return call('cart/update.js', { note: value('notes'), attributes: { 'Preferred delivery day': value('delivery'), 'SNAP Breakfast': money2(state.give), 'People fed': String(state.people) } });
        })
        .then(function () { say('Off to checkout…'); window.location.href = root0 + 'checkout'; })
        .catch(function (err) {
          send.disabled = false;
          say(err && err.shown ? String(err.message) : 'The cart couldn’t be filled. Try again in a minute, or call your rep.', true);
        });
    }
    var again = sheet.querySelector('[data-wh-again]');
    if (again) again.addEventListener('click', function () { if (form) { form.hidden = false; form.reset(); } if (sent) sent.hidden = true; say(noteText); setAmounts({ bags: 0, lbs: 0, ghost: false }); var c = sheet.querySelector('.sf-close'); if (c) c.click(); if (bagsIn) bagsIn.focus(); });
    /* after a sent inquiry, closing the sheet brings the form back for a fresh one */
    sheet.querySelectorAll('.wh-sent [data-sf-close]').forEach(function (b) { b.addEventListener('click', function () { if (quote && form) { setTimeout(function () { form.hidden = false; form.reset(); if (sent) sent.hidden = true; say(noteText); }, 1000); } }); });

    function setAmounts(o) {
      if (shopMode) {
        steps.forEach(function (st) {
          var by = st.getAttribute('data-wh-step') === 'bags' ? o.bagsBy : o.lbsBy;
          var n = by && by[st.getAttribute('data-name')] ? by[st.getAttribute('data-name')] : 0;
          st.querySelector('input').value = String(n); st.classList.toggle('is-on', n > 0);
        });
        if (ghostIn) ghostIn.checked = !!o.ghost;
        tally(); return;
      }
      if (bagsIn) bagsIn.value = String(Math.min(o.bags || 0, Number(bagsIn.max)));
      if (lbsIn) lbsIn.value = String(Math.min(o.lbs || 0, Number(lbsIn.max)));
      if (ghostIn) ghostIn.checked = !!o.ghost;
      render();
    }
    root.whSet = setAmounts;
  }

  /* ---------- the portal: tabs and history ---------- */
  function Tabs(bar) {
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-wh-tab]'));
    function show(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        var panel = doc.getElementById(t.getAttribute('aria-controls')); if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (k) { e.preventDefault(); show(tabs[(i + k + tabs.length) % tabs.length], true); }
      });
    });
    bar.whShow = function (n) { if (tabs[n]) show(tabs[n]); };
  }

  function History(box) {
    var base = feedBase(box), list = box.querySelector('[data-wh-history-list]'), stateEl = box.querySelector('[data-wh-history-state]');
    var quiet = box.hasAttribute('data-wh-quiet'); /* "Earlier orders" under a Shopify buyer's orders: shown only if there are some */
    var count = quiet ? null : doc.querySelector('[data-wh-count]');
    function load() {
      if (!base) { if (!quiet) stateEl.textContent = 'Order history isn’t connected yet.'; return; }
      stateEl.hidden = false; stateEl.textContent = 'Loading your orders…';
      post(base + '/wholesale/history', { token: box.getAttribute('data-wh-token'), sig: box.getAttribute('data-wh-sig') }).then(function (res) {
        if (quiet && !(res.status === 200 && res.body && res.body.ok && (res.body.orders || []).length)) return;
        if (quiet) box.hidden = false;
        if (!(res.status === 200 && res.body && res.body.ok)) { stateEl.textContent = res.body && res.body.error ? String(res.body.error).charAt(0).toUpperCase() + String(res.body.error).slice(1) + '.' : 'Your orders can’t be loaded right now.'; return; }
        var orders = res.body.orders || [];
        list.innerHTML = '';
        if (count) count.textContent = orders.length ? '(' + orders.length + ')' : '';
        if (!orders.length) { stateEl.textContent = 'No orders yet. Your first one will show here.'; return; }
        stateEl.hidden = true;
        orders.forEach(function (o) { list.appendChild(row(o)); });
      }).catch(function () { if (!quiet) stateEl.textContent = 'Your orders can’t be loaded right now. Try again in a minute.'; });
    }
    function row(o) {
      var li = doc.createElement('li'); li.className = 'wh-order';
      var top = doc.createElement('div'); top.className = 'wh-order__top';
      var num = doc.createElement('b'); num.className = 'wh-order__num'; num.textContent = o.number || 'Order';
      var when = doc.createElement('span'); when.className = 'wh-order__date';
      var d = Date.parse(o.date); when.textContent = isNaN(d) ? (o.date || '') : new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'America/Los_Angeles' });
      var st = doc.createElement('span'); st.className = 'wh-status wh-status--' + String(o.status || 'received').toLowerCase().replace(/[^a-z]+/g, '-'); st.textContent = o.status || 'Received';
      top.appendChild(num); top.appendChild(when); top.appendChild(st);
      var what = doc.createElement('p'); what.className = 'wh-order__what';
      var parts = [];
      if (o.bags) parts.push(o.bags + ' retail bag' + (o.bags === 1 ? '' : 's') + (o.ghost ? ' (Ghost Roasting)' : ''));
      if (o.lbs) parts.push(o.lbs + ' lbs by weight');
      what.textContent = (parts.join(' · ') || '—') + (o.delivery ? ' · ' + o.delivery : '');
      var end = doc.createElement('div'); end.className = 'wh-order__end';
      var tot = doc.createElement('b'); tot.className = 'wh-order__total'; tot.textContent = o.total ? money2(o.total) : '';
      end.appendChild(tot);
      if ((o.bags || o.lbs) && doc.querySelector('[data-wh-calc][data-mode="order"]')) { /* only where the old order form still is */
        var again = doc.createElement('button'); again.type = 'button'; again.className = 'wh-link'; again.textContent = 'Order this again';
        again.addEventListener('click', function () {
          var calc = doc.querySelector('[data-wh-calc][data-mode="order"]'), tabs = doc.querySelector('[data-wh-tabs]');
          if (tabs && tabs.whShow) tabs.whShow(0);
          if (calc && calc.whSet) { calc.whSet({ bags: o.bags, lbs: o.lbs, ghost: o.ghost }); var t = calc.querySelector('.wh-ticket'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
        end.appendChild(again);
      }
      li.appendChild(top); li.appendChild(what); li.appendChild(end);
      return li;
    }
    load();
    doc.addEventListener('wh:ordered', load);
  }

  function init(scope) {
    var root = scope || doc;
    Array.prototype.forEach.call(root.querySelectorAll('[data-wh-calc]'), function (el) { if (el.dataset.whBound) return; el.dataset.whBound = '1'; Calc(el); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-wh-tabs]'), function (el) { if (el.dataset.whBound) return; el.dataset.whBound = '1'; Tabs(el); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-wh-history]'), function (el) { if (el.dataset.whBound) return; el.dataset.whBound = '1'; History(el); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-wh-again-shop]'), function (el) {
      if (el.dataset.whBound) return; el.dataset.whBound = '1';
      el.addEventListener('click', function () {
        var o; try { o = JSON.parse(el.getAttribute('data-wh-again-shop')); } catch (e) { return; }
        var lbsBy = {};
        String(o.split || '').split(',').forEach(function (part) { var m = /^\s*(.+?)\s+(\d+)\s*lb\s*$/i.exec(part); if (m) lbsBy[m[1]] = parseInt(m[2], 10); });
        var calc = doc.querySelector('[data-wh-calc][data-mode="shop"]'), tabs = doc.querySelector('[data-wh-tabs]');
        if (tabs && tabs.whShow) tabs.whShow(0);
        if (calc && calc.whSet) { calc.whSet({ bagsBy: o.bags || {}, lbsBy: lbsBy, ghost: o.ghost }); var t = calc.querySelector('.wh-ticket'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }
  window.HereticWholesale = { init: init };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
